<template>
    <div class="login-page">
        <div class="login-box">
            <div class="login-left">
                <div class="slogan">山东心理咨询行业协会</div>
                <img src="@/assets/images/login-img.png" alt="">
            </div>
            <div class="form">
                <div class="content">
                    <div class="login-title">山东心理咨询行业协会用户登录</div>
                    <el-form :rules="rules" ref="formRef" size="large" :model="form" @keyup.enter.down="keyDown">
                        <el-form-item prop="phone">
                            <el-input type="text" clearable v-model="form.phone" placeholder="请输入手机号">
                                <template #prefix>
                                    <i class="iconfont icon-shouji" size="16"></i>
                                </template>
                            </el-input>
                        </el-form-item>
                        <el-form-item prop="code">
                            <el-input v-model="form.code" type="text" placeholder="请输入短信验证码"
                                style="flex:1;margin-right:10px;">
                                <template #prefix>
                                    <i class="iconfont icon-mima" size="16"></i>
                                </template>
                            </el-input>
                            <el-button plain style="height:42px;" @click="sendVerifyCode">{{ count_down }}</el-button>
                        </el-form-item>
                        <el-form-item prop="code_img">
                            <el-row class="w100" :gutter="15">
                                <el-col :span="16">
                                    <el-input type="text" placeholder="请输入图形验证码" v-model="form.code_img" clearable
                                        autocomplete="off">
                                        <template #prefix>
                                            <i class="iconfont icon-yanzhengma" size="16"></i>
                                        </template>
                                    </el-input>
                                </el-col>
                                <el-col :span="8">
                                    <img @click="changeCodeImg" class="code-img" :src="codeUrl + '&id=' + form.codeId"
                                        alt="验证码图片" />
                                </el-col>
                            </el-row>
                        </el-form-item>
                        <el-form-item>
                            <el-checkbox v-model="form.keep">保持会话</el-checkbox>
                        </el-form-item>
                        <el-form-item>
                            <el-button :loading="loading" class="submit-button" type="primary" size="large"
                                @click="login">
                                登录
                            </el-button>
                        </el-form-item>
                        <!--                        <div class="register-link">
                            还没有账号？<router-link to="/users/register">立即注册</router-link>
                        </div>-->
                    </el-form>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { ElMessage } from 'element-plus'
import publics from "@/api/public"
import user from "@/api/user"
import { verifyMobile } from "@/utils/validate"
import { uuid } from "@/utils/random"

export default {
    name: 'Login',
    data() {
        return {
            loading: false,
            codeUrl: '',
            second: 0,
            count_down: '获取验证码',
            timer: null,
            form: {
                phone: '',
                code: '',
                code_img: '',
                codeId: uuid(),
                keep: true
            },
            rules: {
                phone: [
                    { required: true, message: '请输入手机号', trigger: 'blur' },
                    { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
                ],
                code: [
                    { required: true, message: '请输入短信验证码', trigger: 'blur' },
                    { min: 4, max: 6, message: '验证码长度在 4 到 6 个字符', trigger: 'blur' }
                ],
                code_img: [
                    { required: true, message: '请输入图形验证码', trigger: 'blur' },
                    { min: 4, max: 6, message: '验证码长度在 4 到 6 个字符', trigger: 'blur' }
                ]
            }
        }
    },
    created() {
        publics.captcha().then(res => {
            this.codeUrl = res
        })
    },
    methods: {
        // 更新验证码图片
        changeCodeImg() {
            this.form.codeId = uuid()
        },
        // enter键提交
        keyDown(e) {
            if (e.keyCode == 13 || e.keyCode == 100) {
                this.login()
            }
        },
        // 倒计时
        countDown() {
            this.timer = setInterval(() => {
                if (this.second > 0) {
                    this.second = this.second - 1
                    this.count_down = this.second + 'S'
                } else {
                    this.count_down = '获取验证码'
                    clearInterval(this.timer)
                }
            }, 1000)
        },
        // 发送短信验证码
        sendVerifyCode() {
            if (this.second > 0) {
                ElMessage.error('请勿短时间内频繁操作！')
                return false
            }
            if (!verifyMobile(this.form.phone)) {
                ElMessage.error('请输入正确格式的手机号！')
                return false
            }
            this.second = 60
            this.countDown()
            publics.sendSms({
                phone: this.form.phone
            }).then(res => {
                ElMessage.success(res.msg)
            })
        },
        // 登录
        login() {
            this.loading = true
            this.$refs['formRef'].validate((valid) => {
                if (valid) {
                    user.userLoginOrReg({
                        username: this.form.phone,
                        code: this.form.code
                    }).then(res => {
                        if (res) {
                            // 使用 auth 模块的 login action
                            this.$store.dispatch('auth/login', {
                                token: res.data.token,
                                account: res.data.account,
                                memberInfo: res.data.memberInfo
                            })
                            ElMessage.success('登录成功！')
                            this.$router.push('/user/home')
                        } else {
                            this.form.codeId = uuid()
                        }
                        this.loading = false
                    }).catch(() => {
                        this.form.codeId = uuid()
                        this.loading = false
                    })
                } else {
                    this.form.codeId = uuid()
                    this.loading = false
                }
            })
        }
    },
    beforeUnmount() {
        if (this.timer) {
            clearInterval(this.timer)
        }
    }
}
</script>
<style lang="scss" scoped>
.login-page {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: calc(100vh - 200px);
    padding: 40px 0;
}

.login-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    overflow: hidden;
    width: 880px;
    max-width: 95vw;
    padding: 0;
    background: #fff;
    border-radius: 10px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.login-left {
    width: 340px;
    min-width: 340px;
    height: 520px;
    background: #e3eef9;
    position: relative;

    img {
        position: absolute;
        bottom: 86px;
        left: 57px;
        width: 163px;
        opacity: 0.9;
    }

    .slogan {
        margin-top: 110px;
        font-family: "阿里妈妈数黑体";
        font-size: 22px;
        font-weight: 700;
        color: #000;
        text-align: center;
        letter-spacing: 3px;
    }
}

.form {
    flex: 1;
    position: relative;

    .content {
        padding: 40px 48px;

        .login-title {
            text-align: center;
            font-size: 20px;
            font-weight: bold;
            color: #2655a5;
            padding: 10px 20px 30px 20px;
        }
    }

    .submit-button {
        width: 100%;
        letter-spacing: 2px;
        font-weight: 300;
        margin-top: 10px;
        --el-button-bg-color: var(--el-color-primary);
    }

    .register-link {
        text-align: center;
        margin-top: 15px;
        font-size: 14px;
        color: #666;

        a {
            color: #3eaef4;
            text-decoration: none;

            &:hover {
                text-decoration: underline;
            }
        }
    }
}

.code-img {
    width: 100%;
    height: 42px;
    cursor: pointer;
    border-radius: 4px;
}

.w100 {
    width: 100%;
}

@media screen and (max-width: 900px) {
    .login-box {
        flex-direction: column;
        width: 92vw;
        max-width: 480px;
    }

    .login-left {
        display: none;
    }

    .form {
        width: 100%;

        .content {
            padding: 30px 24px;
        }
    }
}
</style>